import {SET_TWO_FACTOR_LOGIN, SETTINGS_PAGE_LOADED} from '../store/actionTypes';

export const settingsPageLoaded = (state = false, action) => {
    switch (action.type) {
        case SETTINGS_PAGE_LOADED:
            return action.status;
        default:
            return state;
    }
};

export const twoFactorLogin = (state = false, action) => {
    switch (action.type) {
        case SET_TWO_FACTOR_LOGIN:
            return action.status;
        default:
            return state;
    }
};
